<script setup lang="ts">
import { computed } from 'vue';
import type { VerticalSummaryProduct } from '../types/catalog-pdf.types';
import ProductCard from './ProductCard.vue';

const PRODUCTS_PER_PAGE = 18;

const props = defineProps<{ title: string; products: VerticalSummaryProduct[] }>();

const pages = computed(() => {
  const result: VerticalSummaryProduct[][] = [];
  for (let i = 0; i < props.products.length; i += PRODUCTS_PER_PAGE) {
    result.push(props.products.slice(i, i + PRODUCTS_PER_PAGE));
  }

  return result.length ? result : [[]];
});
</script>

<template>
  <section v-for="(pageProducts, pageIndex) in pages" :key="pageIndex" class="vertical-summary-page">
    <!-- Page title: logo + category name -->
    <div class="page-title">
      <img src="@/assets/img/black-logo.svg" alt="" class="page-logo" />
      <span>{{ title }}</span>
    </div>

    <!-- Product thumbnail grid: 6 per row, max 3 rows -->
    <div class="product-grid">
      <ProductCard
        v-for="product in pageProducts"
        :key="product.productName"
        :image-source="product.imageUrl"
        :labels="[]">
        <p class="product-name">{{ product.productName }}</p>
      </ProductCard>
    </div>
  </section>
</template>

<style scoped lang="scss">
.vertical-summary-page {
  width: 297mm;
  height: 210mm;
  background-color: var(--pdf-background-light-color);
  page-break-after: always;
  padding: 1rem 1.5rem;
  box-sizing: border-box;
  overflow: hidden;

  .page-title {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 42px;
    margin-bottom: 10px;

    .page-logo {
      width: 16px;
      flex-shrink: 0;
    }

    span {
      font-size: 1.125rem;
      color: var(--primary-dark);
    }
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 160px);
    gap: 10px;

    .product-name {
      font-size: 12px;
      color: var(--primary-dark);
      margin: 10px 0 0;
      text-align: left;
    }
  }
}
</style>
